/**
 * Edições do ENAC.
 *
 * Há dois ENACs por ano. A primeira edição foi 2025.1: cada semestre é uma
 * edição, numerada em sequência. O valor guardado é "ano.semestre" ("2025.1");
 * o rótulo mostra também a edição ("2025.1 - 1ª Edição"). Admin e app usam o
 * mesmo helper para as opções ficarem idênticas.
 */
const PRIMEIRO_ANO_ENAC = 2025;

/**
 * Última edição já realizada, exibida no filtro do aluno.
 *
 * O cadastro (admin) precisa das edições futuras para registrar a próxima prova,
 * mas o filtro do app não deve oferecer edições que ainda não aconteceram.
 * Ao sair uma edição nova, basta avançar esta constante.
 */
export const ULTIMA_EDICAO_PUBLICA = { year: 2026, semester: 1 } as const;

export function numeroDaEdicao(year: number, semester: number): number {
  return (year - PRIMEIRO_ANO_ENAC) * 2 + semester;
}

export function rotuloDaEdicao(year: number, semester: number): string {
  return `${year}.${semester} - ${numeroDaEdicao(year, semester)}ª Edição`;
}

export interface OpcaoDeEdicao {
  value: string;
  label: string;
  year: number;
  semester: number;
}

/**
 * Opções da mais recente para a mais antiga.
 *
 * Sem `ate`, vai até o ano que vem - é o que o cadastro precisa para registrar a
 * próxima prova. O app passa a última edição realizada, para não oferecer
 * edições que ainda não aconteceram.
 */
export function edicoesDoEnac(ate?: { year: number; semester: number }): OpcaoDeEdicao[] {
  const limite = ate ?? { year: new Date().getFullYear() + 1, semester: 2 };
  const opcoes: OpcaoDeEdicao[] = [];
  for (let ano = PRIMEIRO_ANO_ENAC; ano <= limite.year; ano += 1) {
    for (let semester = 1; semester <= 2; semester += 1) {
      if (ano === limite.year && semester > limite.semester) break;
      opcoes.push({
        value: `${ano}.${semester}`,
        label: rotuloDaEdicao(ano, semester),
        year: ano,
        semester,
      });
    }
  }
  return opcoes.reverse();
}
